<template>
  <div>
    <DialogBase
      :visible="dialogVisible"
      title="Thêm mới tin tức"
      size="xl"
      top="20px"
      :close-on-click-modal="false"
      panel-icon="el-icon-edit"
      panel-title="Soạn tin tức"
      panel-subtitle="Nhập nội dung, đính kèm tệp và chọn phạm vi gửi"
      @update:visible="handleVisibleUpdate"
    >
      <el-form ref="updateData" :model="fromData" :rules="rules" label-position="top" size="small" class="notify-two-col-form">
        <el-row :gutter="20">
          <!-- Cột trái (62%): Soạn thảo Tiêu đề, Nội dung & Đường dẫn -->
          <el-col :span="15">
            <div class="left-form-pane">
              <el-form-item prop="title" label="Tiêu đề thông báo">
                <el-input placeholder="Nhập tiêu đề thông báo..." v-model="fromData.title" clearable></el-input>
              </el-form-item>

              <el-form-item label="Nội dung thông báo" prop="content">
                <div class="content-toolbar">
                  <div class="mode-switch-group">
                    <el-radio-group v-model="contentViewMode" size="mini">
                      <el-radio-button label="editor">
                        <i class="el-icon-edit" /> Soạn thảo
                      </el-radio-button>
                      <el-radio-button label="preview">
                        <i class="el-icon-view" /> Xem thực tế
                      </el-radio-button>
                      <el-radio-button label="source">
                        <i class="el-icon-tickets" /> Mã nguồn HTML
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                  <div class="dialog-switch-group">
                    <el-button
                      v-if="contentViewMode === 'preview'"
                      size="mini"
                      type="primary"
                      plain
                      icon="el-icon-full-screen"
                      @click="handleOpenPreviewDialog"
                    >
                      Mở cửa sổ lớn
                    </el-button>
                    <el-button
                      v-if="contentViewMode === 'source'"
                      size="mini"
                      type="warning"
                      plain
                      icon="el-icon-document-copy"
                      @click="handleCopyHtmlSource"
                    >
                      Sao chép mã
                    </el-button>
                    <el-button
                      v-if="contentViewMode === 'source'"
                      size="mini"
                      type="info"
                      plain
                      icon="el-icon-full-screen"
                      @click="handleOpenSourceDialog"
                    >
                      Cửa sổ mã nguồn
                    </el-button>
                  </div>
                </div>

                <!-- Mode 1: Editor -->
                <div v-show="contentViewMode === 'editor'">
                  <TextEditor v-model="fromData.content" height="380px" ref="textEditor"></TextEditor>
                </div>

                <!-- Mode 2: Xem thực tế (Rendered HTML) -->
                <div v-show="contentViewMode === 'preview'" class="html-preview-container">
                  <div class="preview-device-card">
                    <div class="preview-card-header">
                      <span class="preview-title">{{ fromData.title || 'Tiêu đề thông báo' }}</span>
                      <el-tag size="mini" type="success">Xem thực tế</el-tag>
                    </div>
                    <div class="preview-card-body">
                      <div v-if="fromData.content" class="html-content-render" v-html="fromData.content"></div>
                      <div v-else class="preview-empty-text">
                        <i class="el-icon-document-remove" /> Chưa có nội dung để hiển thị
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Mode 3: Hiển thị mã nguồn HTML -->
                <div v-show="contentViewMode === 'source'" class="html-source-container">
                  <div class="source-code-header">
                    <span class="source-info"><i class="el-icon-tickets" /> Mã nguồn HTML (có thể xem và chỉnh sửa):</span>
                  </div>
                  <el-input
                    type="textarea"
                    :rows="15"
                    v-model="fromData.content"
                    placeholder="Mã nguồn HTML..."
                    class="source-code-textarea"
                  ></el-input>
                </div>
              </el-form-item>

              <el-form-item prop="link" label="Đường dẫn liên kết đính kèm">
                <el-input placeholder="https://example.com..." v-model="fromData.link" prefix-icon="el-icon-link" clearable></el-input>
              </el-form-item>
            </div>
          </el-col>

          <!-- Cột phải (38%): Phạm vi, Thời gian & Tệp đính kèm -->
          <el-col :span="9">
            <div class="right-form-pane">
              <!-- Card 1: Phạm vi nhận -->
              <div class="notify-card-box">
                <div class="card-box-header">
                  <i class="el-icon-s-custom" />
                  <span class="card-title">Phạm vi nhận tin</span>
                </div>
                <div class="card-box-body">
                  <div class="nfs-scope-selector">
                    <el-select v-model="scopeForm" class="w-full" placeholder="Chọn phạm vi" style="width: 100%;" @change="handleChangeScopeApply">
                      <el-option v-for="(item, index) in listScopeApply" :key="index" :label="item.label" :value="item.value" />
                    </el-select>
                  </div>

                  <div class="nfs-scope-buttons" style="margin-top: 10px; display: flex; gap: 8px;">
                    <el-button 
                      class="nfs-choice-btn" 
                      :type="isShowButtonScope.class ? 'primary' : 'info'"
                      size="small" 
                      :plain="true" 
                      :disabled="!isShowButtonScope.class" 
                      icon="el-icon-folder"
                      @click="handleShowApplyKid"
                      style="flex: 1;"
                    >
                      Chọn Lớp ({{ applyForm.kids.length }})
                    </el-button>
                    
                    <el-button 
                      class="nfs-choice-btn" 
                      :type="isShowButtonScope.employee ? 'primary' : 'info'"
                      size="small" 
                      :plain="true" 
                      :disabled="!isShowButtonScope.employee"
                      icon="el-icon-user-solid"
                      @click="handleShowApplyEmployee"
                      style="flex: 1;"
                    >
                      Nhân sự ({{ applyForm.employees.length }})
                    </el-button>
                  </div>

                  <div class="nfs-scope-lists" style="margin-top: 10px;">
                    <el-row :gutter="8">
                      <!-- Học sinh -->
                      <el-col :span="12">
                        <div :class="['nfs-scope-list-box', { 'is-disabled': !isShowButtonScope.class }]">
                          <div class="nfs-list-box-title">
                            <div class="title-left">
                              <i class="el-icon-folder-opened" style="color: #eab308; font-size: 15px;" />
                              <span>Học sinh ({{ applyForm.kids.length }})</span>
                            </div>
                            <span class="nfs-title-tag">
                              {{ scopeForm === 'all' ? 'Tất cả' : (scopeForm === 'class' ? 'Lớp học' : 'Tất cả') }} ({{ applyForm.kids.length }})
                            </span>
                          </div>
                          <div class="nfs-list-box-content">
                            <template v-if="applyForm.kids.length > 0">
                              <div
                                v-for="(kid, index) in applyForm.kids"
                                :key="index"
                                class="nfs-apply-pill"
                              >
                                <i class="el-icon-circle-check text-green-500" />
                                <span>{{ kid.kidsName || kid.kidName || kid.fullName }}<span v-if="kid.className"> ({{ kid.className }})</span></span>
                              </div>
                            </template>
                            <div v-else class="nfs-no-selection">
                              {{ isShowButtonScope.class ? 'Chưa chọn học sinh nào' : 'Chưa chọn' }}
                            </div>
                          </div>
                        </div>
                      </el-col>

                      <!-- Nhân sự -->
                      <el-col :span="12">
                        <div :class="['nfs-scope-list-box', { 'is-disabled': !isShowButtonScope.employee }]">
                          <div class="nfs-list-box-title">
                            <div class="title-left">
                              <i class="el-icon-s-custom" style="color: #2563eb; font-size: 15px;" />
                              <span>Nhân sự ({{ applyForm.employees.length }})</span>
                            </div>
                            <span class="nfs-title-tag">
                              {{ scopeForm === 'all' ? 'Tất cả' : (scopeForm === 'employee' ? 'Nhân sự' : 'Tất cả') }} ({{ applyForm.employees.length }})
                            </span>
                          </div>
                          <div class="nfs-list-box-content">
                            <template v-if="applyForm.employees.length > 0">
                              <div
                                v-for="(employee, index) in applyForm.employees"
                                :key="index"
                                class="nfs-apply-pill"
                              >
                                <i class="el-icon-circle-check text-green-500" />
                                <span>{{ employee.teacherName || employee.fullName || employee.employeeName }}</span>
                              </div>
                            </template>
                            <div v-else class="nfs-no-selection">
                              {{ isShowButtonScope.employee ? 'Chưa chọn nhân sự nào' : 'Chưa chọn' }}
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>

              <!-- Card 2: Thời gian gửi -->
              <div class="notify-card-box">
                <div class="card-box-header">
                  <i class="el-icon-time" />
                  <span class="card-title">Thời gian gửi</span>
                </div>
                <div class="card-box-body">
                  <el-radio-group v-model="fromData.sendType" size="small" @change="handleSendTypeChange" class="send-type-segmented">
                    <el-radio-button label="IMMEDIATE"><i class="el-icon-s-promotion" /> Gửi ngay</el-radio-button>
                    <el-radio-button label="SCHEDULED"><i class="el-icon-date" /> Lên lịch gửi</el-radio-button>
                  </el-radio-group>
                  <div v-if="fromData.sendType === 'SCHEDULED'" style="margin-top: 10px;">
                    <el-date-picker
                      v-model="fromData.scheduledTime"
                      type="datetime"
                      placeholder="Chọn ngày giờ gửi"
                      :picker-options="pickerOptions"
                      style="width: 100%;"
                      size="small"
                      @focus="resetScheduledTime"
                    ></el-date-picker>
                  </div>
                </div>
              </div>

              <!-- Card 3: Tệp & Hình ảnh đính kèm (Drag and Drop) -->
              <div class="notify-card-box">
                <div class="card-box-header">
                  <i class="el-icon-paperclip" />
                  <span class="card-title">Đính kèm ảnh & tệp</span>
                  <span class="badge-file-count">Tổng: {{ totalFiles }}/3 tệp</span>
                </div>
                <div class="card-box-body">
                  <!-- Drag & Drop Upload Hình Ảnh -->
                  <div class="upload-drop-section">
                    <span class="upload-sublabel"><i class="el-icon-picture-outline" /> Hình ảnh đính kèm:</span>
                    <el-upload
                      drag
                      @click.native="resetWaningImg"
                      action="/api/upload/"
                      list-type="picture"
                      :auto-upload="false"
                      :on-preview="handlePictureCardPreview"
                      :file-list="imageFileList"
                      :on-change="handleChangeImg"
                      :on-remove="handleRemoveImg"
                      accept=".jpg,.jpeg,.png,.webp"
                      multiple
                      ref="uploadImg"
                      :limit="3"
                      :on-exceed="handleExceed"
                      :disabled="totalFiles >= 3"
                      class="drag-dropzone-uploader"
                      :class="{ 'hide-trigger': totalFiles >= 3 }"
                    >
                      <i class="el-icon-upload" />
                      <div class="el-upload__text">Kéo thả ảnh vào đây hoặc <em>chọn tệp</em></div>
                    </el-upload>
                  </div>

                  <!-- Drag & Drop Upload Tài Liệu -->
                  <div class="upload-drop-section" style="margin-top: 12px;">
                    <span class="upload-sublabel"><i class="el-icon-document" /> File tài liệu bổ sung:</span>
                    <el-upload
                      drag
                      action="/api/upload/"
                      :auto-upload="false"
                      :file-list="excelFileList"
                      :on-change="handleChangeFile"
                      :on-remove="handleRemoveExcel"
                      accept=".xls,.xlsx,.doc,.docx,.pdf,.txt,.zip,.rar"
                      multiple
                      ref="uploadExcel"
                      :limit="3"
                      :on-exceed="handleExceed"
                      :disabled="totalFiles >= 3"
                      class="drag-dropzone-file-uploader"
                    >
                      <i class="el-icon-upload" />
                      <div class="el-upload__text">Kéo thả file vào đây hoặc <em>chọn tệp</em></div>
                    </el-upload>
                  </div>

                  <el-progress
                    style="margin-top: 10px;"
                    :percentage="percentage"
                    v-if="showProgress"
                    :color="colors"
                  ></el-progress>
                </div>
              </div>

            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer sk-dialog-footer">
        <el-button type="danger" size="medium" @click.prevent="resetField('updateData')">
          <i class="el-icon-circle-close" />
          <span>Đóng</span>
        </el-button>
        <el-button type="success" size="medium" :loading="loadingButton" mini @click.prevent="submitForm('updateData')">
          <i class="el-icon-circle-check" />
          <span>Lưu</span>
        </el-button>
      </span>
    </DialogBase>
    <DialogBase
      :visible="dialogVisible1"
      width="30%"
      :show-footer="false"
      panel-icon="el-icon-picture-outline"
      panel-title="Xem trước ảnh"
      @update:visible="handlePreviewVisibleUpdate"
    >
      <img width="100%" :src="dialogImageUrl" alt />
    </DialogBase>

    <!-- Dialog Popup Xem Thực Tế (Preview HTML) -->
    <DialogBase
      :visible="dialogPreviewHtmlVisible"
      title="Xem trước hiển thị nội dung (HTML)"
      size="lg"
      top="50px"
      panel-icon="el-icon-view"
      panel-title="Hiển thị nội dung thực tế"
      panel-subtitle="Xem trước giao diện hiển thị chính xác của tin tức"
      :show-confirm="false"
      cancel-text="Đóng"
      @cancel="dialogPreviewHtmlVisible = false"
      @update:visible="dialogPreviewHtmlVisible = $event"
    >
      <div class="dialog-html-preview-wrapper">
        <h3 class="preview-heading-title">{{ fromData.title || 'Chưa có tiêu đề' }}</h3>
        <div class="preview-divider"></div>
        <div v-if="fromData.content" class="html-content-render dialog-render" v-html="fromData.content"></div>
        <div v-else class="preview-empty-text">
          <i class="el-icon-document-remove" /> Chưa có nội dung HTML
        </div>
      </div>
    </DialogBase>

    <!-- Dialog Popup Mã Nguồn (Source HTML) -->
    <DialogBase
      :visible="dialogSourceHtmlVisible"
      title="Mã nguồn HTML nội dung"
      size="lg"
      top="50px"
      panel-icon="el-icon-tickets"
      panel-title="Mã nguồn HTML"
      panel-subtitle="Xem và chỉnh sửa trực tiếp mã nguồn HTML"
      cancel-text="Đóng"
      confirm-text="Sao chép mã"
      confirm-icon="el-icon-document-copy"
      confirm-type="primary"
      @cancel="dialogSourceHtmlVisible = false"
      @confirm="handleCopyHtmlSource"
      @update:visible="dialogSourceHtmlVisible = $event"
    >
      <div class="dialog-html-source-wrapper">
        <el-input
          type="textarea"
          :rows="18"
          v-model="fromData.content"
          placeholder="Mã nguồn HTML..."
          class="source-code-textarea"
        ></el-input>
      </div>
    </DialogBase>
    <ApplyKidSurveyForm :is-open="isDialogApply.kid" @closeDialog="handleCloseDialogApplyKid"
      @confirmData="handleConfirmKidsApply" ref="applyKidSurveyForm" />
    <ApplyEmployeeSurveyForm :is-open="isDialogApply.employee" @closeDialog="handleCloseDialogApplyEmployee"
      @confirmData="handleConfirmEmployeesApply" ref="applyEmployeeSurveyForm" />
  </div>
</template>

<script>
import NotifySchoolService from "@/services/SchoolService/NotifySchoolService";
import TextEditor, { ensureInlineTableStyles } from "@/views/common/TextEditor.vue";
import ApplyKidSurveyForm from "@/views/survey_form/dialog/ApplyKidSurveyForm.vue";
import ApplyEmployeeSurveyForm from "@/views/survey_form/dialog/ApplyEmployeeSurveyForm.vue";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";
import { notifySendType } from "../../constant/listCommon";
import moment from 'moment';
import DialogBase from "@/components/DialogBase.vue";

export default {
  components: { TextEditor, ApplyKidSurveyForm, ApplyEmployeeSurveyForm, DialogBase },
  props: {
    dialogVisible: null,
  },
  mixins: [parseInfoKidVietnameseMixin],
  computed: {
    totalFiles() {
      return this.imageFileList.length + this.excelFileList.length;
    },
    pickerOptions() {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const currentSecond = now.getSeconds();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const selectedDate = new Date(this.fromData.scheduledTime || now);
      let selectableRange = [];

      if (selectedDate.getTime() <= today.getTime() + 8.64e7) {
        // Nếu là ngày hiện tại, giới hạn thời gian từ giờ/phút/giây hiện tại
        selectableRange = [`${currentHour}:${currentMinute}:${currentSecond} - 23:59:59`];
      } else {
        // Nếu là ngày trong tương lai, cho phép toàn bộ thời gian trong ngày
        selectableRange = ['00:00:00 - 23:59:59'];
      }

      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // Vô hiệu hóa các ngày trước ngày hiện tại
        },
        selectableRange,
      };
    },
  },
  data() {
    return {
      showAllKids: false,
      showAllEmployees: false,
      contentViewMode: "editor",
      dialogPreviewHtmlVisible: false,
      dialogSourceHtmlVisible: false,
      isProcessing: false,
      countFile: 0,
      dialogImageUrl: "",
      dialogVisible1: false,
      statusUpdate: false,
      messageWarningFile: false,
      messageWarningImg: false,
      colors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#6f7ad3", percentage: 100 },
      ],
      imageFileList: [],
      excelFileList: [],
      percentage: 0,
      loadingButton: false,
      showProgress: false,
      multipartFileList: [],
      fromData: {
        title: "",
        content: null,
        link: "",
        multipartFileList: [],
        sendType: notifySendType.IMMEDIATE, // Mặc định là gửi ngay
        scheduledTime: null, // Thời gian lên lịch gửi
      },
      rules: {
        title: [
          {
            required: true,
            message: "Tiêu đề không được để trống",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "Nội dung không được để trống",
            trigger: "blur",
          },
        ],
        sendType: [
          {
            required: true,
            message: "Vui lòng chọn thời gian gửi",
            trigger: "change",
          },
        ],
        scheduledTime: [
          {
            required: true,
            message: "Vui lòng chọn ngày giờ gửi",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.fromData.sendType === "SCHEDULED" && !value) {
                callback(new Error("Vui lòng chọn ngày giờ gửi"));
              } else if (this.fromData.sendType === "SCHEDULED" && value < new Date()) {
                callback(new Error("Thời gian gửi phải là trong tương lai"));
              } else {
                callback();
              }
            },
          },
        ]
      },
      scopeForm: "all",
      listScopeApply: [
        { value: "all", label: "Tất cả" },
        { value: "class", label: "Lớp" },
        { value: "employee", label: "Nhân sự" },
      ],
      isShowButtonScope: {
        class: true,
        employee: true,
      },
      isDialogApply: {
        kid: false,
        employee: false,
      },
      applyForm: {
        classes: [],
        kids: [],
        departments: [],
        employees: [],
      },
    };
  },
  created() {
    this.$store.dispatch('classStore/fetchDataClassListCommon')
  },
  methods: {
    handleVisibleUpdate(value) {
      if (!value) {
        this.closeDialog();
      }
    },
    handlePreviewVisibleUpdate(value) {
      this.dialogVisible1 = value;
    },
    resetField(form) {
      this.$refs.textEditor.handleRemoveMultiImage();
      this.closeDialogByButton(form)
    },
    handleRemove(file) {
      this.$refs.upload.clearFiles();
      let index = this.fromData.multipartFileList.indexOf(file);
      if (index >= 0) {
        this.fromData.multipartFileList.splice(index, 1);
      }
    },
    submitForm(form) {
      this.multipartFileList = [...this.imageFileList, ...this.excelFileList];

      this.statusUpdate = true;
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          this.fromData.content = ensureInlineTableStyles(this.fromData.content);
          let formDatas = new FormData();
          formDatas.append("title", this.fromData.title);
          formDatas.append("content", this.fromData.content);
          formDatas.append("link", this.fromData.link);
          formDatas.append("scope", this.scopeForm);
          formDatas.append("sendType", this.fromData.sendType);
          if (this.fromData.sendType === "SCHEDULED" && this.fromData.scheduledTime) {
            formDatas.append("scheduledTime", moment(this.fromData.scheduledTime).format('YYYY-MM-DDTHH:mm:ssZ'));
          }
          if (this.scopeForm === "class" || this.scopeForm === "all") {
            this.applyForm.kids.forEach((kid) => {
              formDatas.append("idKidsList", kid.idKid);
            });
          }
          if (this.scopeForm === "employee" || this.scopeForm === "all") {
            this.applyForm.employees.forEach((employee) => {
              formDatas.append("idTeacherList", employee.idTeacher);
            });
          }

          if (this.multipartFileList && this.multipartFileList.length > 0) {
            this.showProgress = true;
            this.increase();
            this.multipartFileList.forEach((file) => {
              formDatas.append("multipartFileList", file.raw);
            });
          }
          NotifySchoolService.createNotifySchool(formDatas)
            .then((response) => {
              this.$message({
                message: response.data.message,
                type: "success",
              });
              this.handleSaveImagePost();
              this.showProgress = false;
              this.stopIncrease();
              this.messageWarningFile = false;
              this.messageWarningImg = false;
              setTimeout(() => {
                this.closeDialogByButton(form);
              }, 500);
            })
            .catch((err) => {
              this.showProgress = false;
              this.messageWarningFile = false;
              this.messageWarningImg = false;
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.messageWarningFile = false;
                this.messageWarningImg = false;
                this.loadingButton = false;
              }, 500);
            });
        }
      });
    },
    handleExceed() {
      this.$message.warning(`Chỉ được phép chọn tối đa 3 file`);
    },
    handleRemoveImg(file, fileList) {
      if (Array.isArray(fileList)) {
        this.imageFileList = fileList;
      } else if (file) {
        this.imageFileList = this.imageFileList.filter((item) => item !== file && item.name !== file.name && item.uid !== file.uid);
      } else {
        this.imageFileList = [];
      }
    },
    handleRemoveExcel(file, fileList) {
      if (Array.isArray(fileList)) {
        this.excelFileList = fileList;
      } else if (file) {
        this.excelFileList = this.excelFileList.filter((item) => item !== file && item.name !== file.name && item.uid !== file.uid);
      } else {
        this.excelFileList = [];
      }
    },
    handleSaveImagePost() {
      this.$refs.textEditor.handleSetActiveImagePost()
    },
    handleOpenPreviewDialog() {
      this.fromData.content = ensureInlineTableStyles(this.fromData.content);
      this.dialogPreviewHtmlVisible = true;
    },
    handleOpenSourceDialog() {
      this.fromData.content = ensureInlineTableStyles(this.fromData.content);
      this.dialogSourceHtmlVisible = true;
    },
    handleCopyHtmlSource() {
      if (!this.fromData.content) {
        this.$message.warning("Nội dung HTML đang trống");
        return;
      }
      this.fromData.content = ensureInlineTableStyles(this.fromData.content);
      const textToCopy = this.fromData.content;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(() => {
          this.$message.success("Đã sao chép mã nguồn HTML vào clipboard!");
        }).catch(() => {
          this.fallbackCopyText(textToCopy);
        });
      } else {
        this.fallbackCopyText(textToCopy);
      }
    },
    fallbackCopyText(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        this.$message.success("Đã sao chép mã nguồn HTML!");
      } catch (err) {
        this.$message.error("Không thể sao chép tự động");
      }
      document.body.removeChild(textArea);
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.handleRemoveImg()
        this.handleRemoveExcel()
        this.$refs["updateData"].resetFields();
        this.scopeForm = "all";
        this.applyForm = { classes: [], kids: [], departments: [], employees: [] };
        this.isShowButtonScope = { class: true, employee: true };
      }, 300);
      this.contentViewMode = "editor";
      this.dialogPreviewHtmlVisible = false;
      this.dialogSourceHtmlVisible = false;
      this.fromData.sendType = notifySendType.IMMEDIATE;
      this.fromData.scheduledTime = null;
      this.$refs.textEditor.handleRemoveMultiImage();
    },
    //click when click button
    closeDialogByButton(from) {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.handleRemoveImg()
        this.handleRemoveExcel();
        this.imageFileList = [];
        this.excelFileList = [];
        this.multipartFileList = []
        this.fromData.multipartFileList = []
        this.$refs[from].resetFields();
        this.messageWarningFile = false;
        this.messageWarningImg = false;
        this.scopeForm = "all";
        this.applyForm = { classes: [], kids: [], departments: [], employees: [] };
        this.fromData.sendType = notifySendType.IMMEDIATE;
        this.fromData.scheduledTime = null;
        this.isShowButtonScope = { class: true, employee: true };
      }, 300);
      this.contentViewMode = "editor";
      this.dialogPreviewHtmlVisible = false;
      this.dialogSourceHtmlVisible = false;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
    },
    increase() {
      this.interval = window.setInterval(() => {
        this.percentage += 5;
        if (this.percentage > 90) {
          this.percentage = 90;
        }
      }, 50);
    },
    stopIncrease() {
      clearInterval(this.interval);
      this.percentage = 100;
    },

    handleChangeImg(file, fileList) {
      let totalFiles = fileList.length + this.excelFileList.length;
      if (totalFiles <= 3) {
        if (file.raw.type.startsWith("image/")) {
          this.imageFileList = fileList;
        }
      } else {
        if (!this.messageWarningImg) {
          this.$message.warning("Tải lên tối đa 3 file");
          this.messageWarningImg = true;
        }
        fileList.forEach(x => {
          this.handleRemoveImg(x);
        })
      }
    },

    handleChangeFile(file, fileList) {
      let totalFiles = this.imageFileList.length + fileList.length;
      if (totalFiles <= 3) {
        if (!file.raw.type.startsWith("image/")) {
          this.excelFileList = fileList;
        }
      } else {
        if (!this.messageWarningFile) {
          this.$message.warning("Tải lên tối đa 3 file");
          this.messageWarningFile = true;
        }
        fileList.forEach(x => {
          this.handleRemoveExcel(x);
        })
      }
    },
    resetWaningFile() {
      this.messageWarningFile = false;
    },
    resetWaningImg() {
      this.messageWarningImg = false;
    },
    handleChangeScopeApply(value) {
      switch (value) {
        case "all":
          this.isShowButtonScope.class = true;
          this.isShowButtonScope.employee = true;
          break;
        case "class":
          this.isShowButtonScope.class = true;
          this.isShowButtonScope.employee = false;
          break;
        case "employee":
          this.isShowButtonScope.class = false;
          this.isShowButtonScope.employee = true;
          break;
      }
    },
    handleShowApplyKid() {
      this.isDialogApply.kid = true;
      this.$refs.applyKidSurveyForm.initialDataApply(this.applyForm.classes, this.getDataIdKids(this.applyForm.kids));
    },
    getDataIdKids(kids) {
      return kids.map(kid => kid.idKid);
    },
    handleCloseDialogApplyKid() {
      this.isDialogApply.kid = false;
    },
    handleConfirmKidsApply(value) {
      this.applyForm.classes = value.classesApply;
      this.applyForm.kids = value.kidsApply;
      this.syncScopeWithRecipients();
      this.handleCloseDialogApplyKid();
    },
    handleShowApplyEmployee() {
      this.isDialogApply.employee = true;
      this.$refs.applyEmployeeSurveyForm.initialDataApply(this.applyForm.departments, this.applyForm.employees);
    },
    handleCloseDialogApplyEmployee() {
      this.isDialogApply.employee = false;
    },
    handleConfirmEmployeesApply(value) {
      this.applyForm.departments = value.departmentsApply;
      this.applyForm.employees = value.employeesApply;
      this.syncScopeWithRecipients();
      this.handleCloseDialogApplyEmployee();
    },
    syncScopeWithRecipients() {
      const hasKids = this.applyForm.kids.length > 0;
      const hasEmployees = this.applyForm.employees.length > 0;

      // Đồng bộ scope theo đúng nhóm người nhận đã chọn.
      // Khi có cả học sinh và nhân sự thì đây là phạm vi tất cả.
      if (hasKids && hasEmployees) {
        this.scopeForm = "all";
      } else if (hasKids) {
        this.scopeForm = "class";
      } else if (hasEmployees) {
        this.scopeForm = "employee";
      }

      this.handleChangeScopeApply(this.scopeForm);
    },
    handleSendTypeChange(value) {
      if (value === 'SCHEDULED' && this.fromData.sendType !== 'SCHEDULED') {
        this.fromData.scheduledTime = null; // Reset scheduledTime when switching to SCHEDULED
      }
    },
    resetScheduledTime() {
      this.fromData.scheduledTime = null; // Reset scheduledTime when the date picker is focused
    }
  }

};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

/deep/ .el-input__inner {
  border: none;
  border-radius: 0;
  resize: none;
  padding-left: 0;
  padding-right: 0;
  border-bottom: 1px solid #d9d9d9;
}

/* ─── Scope Card ───────────────────────────────────── */
.nfs-scope-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  padding: 16px;
}

.nfs-scope-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.nfs-scope-label {
  font-weight: 600;
  color: #475569;
  font-size: 13.5px;
}

/deep/ .nfs-scope-select .el-input__inner {
  border-radius: 8px;
  background: #f8fafc;
  border-color: #e2e8f0;
  width: 200px;
}

.nfs-scope-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid #f1f5f9;
  margin-bottom: 12px;
}

.nfs-choice-btn {
  min-width: 140px;
  font-weight: 600;
  border-radius: 8px !important;
  
  &.el-button--primary {
    background-color: #eff6ff;
    border-color: #bfdbfe;
    color: #2563eb;
    
    &:hover {
      background-color: #2563eb;
      color: #ffffff;
      border-color: #2563eb;
    }
  }
}

.nfs-scope-list-box {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  padding: 12px;
  min-height: 180px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  
  &.is-disabled {
    background-color: #f1f5f9;
    border: 1px dashed #cbd5e1;
    opacity: 0.6;
    
    .nfs-list-box-title {
      color: #94a3b8;
      border-bottom-color: #e2e8f0;
      
      i {
        color: #94a3b8;
      }
    }
  }
}

.nfs-list-box-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  font-weight: 700;
  color: #1e293b;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 8px;
  margin-bottom: 10px;
  
  i {
    color: #eab308;
    font-size: 16px;
  }
}

.nfs-list-box-content {
  max-height: 125px;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 4px;
  padding-right: 2px;
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 2px;
  }
}

.nfs-apply-pill {
  display: flex !important;
  align-items: center;
  gap: 6px;
  width: 100% !important;
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #dbeafe;
  padding: 5px 8px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 500;
  box-sizing: border-box;
  line-height: 1.3;
  word-break: break-word;

  i {
    font-size: 13px;
    color: #10b981;
    flex-shrink: 0;
  }
}

.nfs-no-selection {
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
  padding: 12px 0;
  font-style: italic;
}

/* ─── Bo góc Form Inputs ───────────────────────────── */
/deep/ .el-form-item__label {
  font-weight: 600;
  color: #475569;
}

/deep/ .el-input__inner {
  border-radius: 8px;
  background: #f8fafc;
  border-color: #e2e8f0;
}

/deep/ .el-input__inner:focus {
  border-color: #2563eb;
  background: #ffffff;
}

/* Upload image area */
/deep/ .el-upload--picture-card {
  border-radius: 10px;
  background-color: #f8fafc;
  border: 1px dashed #cbd5e1;
  width: 100px;
  height: 100px;
  line-height: 100px;
  
  &:hover {
    border-color: #2563eb;
    background-color: #f0f6ff;
  }
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  border-radius: 10px;
}

/* Footer buttons */
/deep/ .sk-dialog-footer .el-button {
  border-radius: 8px;
  font-weight: 600;
  padding: 10px 20px;
}

.short-date-picker {
  width: 250px !important;
}

/deep/ .short-date-picker .el-input__inner {
  padding-left: 30px;
}

/* Ẩn vùng upload trigger (ô chọn file) khi đã đủ số file */
.hide-trigger /deep/ .el-upload-list--picture-card .el-upload-list__item.is-upload {
  display: none !important;
}
.hide-trigger /deep/ .el-upload__inner {
  display: none !important;
}
/* Nếu vẫn còn viền của trigger, ẩn các thành phần hộp trigger và loại bỏ border */
.hide-trigger /deep/ .el-upload--picture-card {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}
.hide-trigger /deep/ .el-upload-list--picture-card .el-upload-list__item.is-upload {
  display: none !important;
}
.hide-trigger /deep/ .el-upload-list--picture-card {
  padding-left: 0 !important;
}

/* ─── Mode Switcher & Content Preview / Source ────── */
.content-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 8px;
}

.preview-device-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  min-height: 350px;
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.preview-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  .preview-title {
    font-weight: 700;
    font-size: 15px;
    color: #1e293b;
  }
}

.preview-card-body {
  padding: 20px;
  flex-grow: 1;
}

.preview-empty-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #94a3b8;
  font-style: italic;
  min-height: 200px;
  font-size: 14px;
}

.html-source-container {
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  overflow: hidden;
  background: #0f172a;
}

.source-code-header {
  padding: 8px 14px;
  background: #1e293b;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 500;
  border-bottom: 1px solid #334155;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/ .source-code-textarea .el-textarea__inner {
  font-family: Consolas, Monaco, "Courier New", monospace !important;
  font-size: 13px;
  line-height: 1.5;
  background-color: #0f172a;
  color: #38bdf8;
  border: none;
  border-radius: 0;
  padding: 12px 16px;

  &::placeholder {
    color: #64748b;
  }
  &:focus {
    border: none;
    box-shadow: none;
  }
}

.dialog-html-preview-wrapper {
  background: #ffffff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  min-height: 300px;
  max-height: 60vh;
  overflow-y: auto;
}

.preview-heading-title {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.preview-divider {
  height: 1px;
  background: #e2e8f0;
  margin-bottom: 16px;
}

.dialog-html-source-wrapper {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #cbd5e1;
}

/* ─── HTML Content Render Styles ───────────────────── */
.html-content-render {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 14.5px;
  line-height: 1.6;
  color: #1e293b;
  word-break: break-word;

  /deep/ h1, /deep/ h2, /deep/ h3, /deep/ h4, /deep/ h5, /deep/ h6 {
    font-weight: 700;
    color: #0f172a;
    margin-top: 1.2em;
    margin-bottom: 0.6em;
    line-height: 1.3;
  }

  /deep/ h1 { font-size: 1.75em; }
  /deep/ h2 { font-size: 1.4em; }
  /deep/ h3 { font-size: 1.2em; }

  /deep/ p {
    margin-top: 0;
    margin-bottom: 0.8em;
  }

  /deep/ a {
    color: #2563eb;
    text-decoration: underline;
    &:hover {
      color: #1d4ed8;
    }
  }

  /deep/ img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 8px 0;
    display: inline-block;
  }

  /deep/ blockquote {
    border-left: 4px solid #3b82f6;
    background-color: #eff6ff;
    margin: 1em 0;
    padding: 10px 16px;
    border-radius: 0 8px 8px 0;
    color: #1e40af;
    font-style: italic;
  }

  /deep/ table {
    border-collapse: collapse;
    width: 100%;
    margin: 1em 0;

    td, th {
      border: 1px solid #cbd5e1;
      padding: 8px 12px;
      text-align: left;
    }

    th {
      background-color: #f1f5f9;
      font-weight: 600;
    }
  }

  /deep/ ul, /deep/ ol {
    padding-left: 24px;
    margin-bottom: 1em;
  }

  /deep/ li {
    margin-bottom: 0.4em;
  }

  /deep/ pre, /deep/ code {
    font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
    background-color: #f1f5f9;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 0.9em;
  }

  /deep/ pre {
    padding: 12px;
    overflow-x: auto;
    code {
      padding: 0;
      background: transparent;
    }
  }
}

/* ─── 2-Column Dialog & Card Box Styles ───────────────────── */
.notify-two-col-form {
  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #334155;
    padding-bottom: 4px;
    font-size: 13px;
  }
}

.notify-card-box {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);

  .card-box-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f5f9;

    i {
      font-size: 16px;
      color: #2563eb;
    }
    .card-title {
      font-weight: 600;
      font-size: 13px;
      color: #1e293b;
    }
    .badge-file-count {
      margin-left: auto;
      font-size: 11px;
      font-weight: 600;
      color: #64748b;
      background: #f1f5f9;
      padding: 2px 8px;
      border-radius: 10px;
    }
  }
}

.nfs-scope-list-box {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 8px 10px;
  transition: all 0.2s ease;
  
  &.is-disabled {
    background-color: #f8fafc;
    border: 1px dashed #cbd5e1;
    opacity: 0.6;
  }
}

.nfs-list-box-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 6px;
  margin-bottom: 6px;
  
  .title-left {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12.5px;
    font-weight: 700;
    color: #1e293b;
  }

  .nfs-title-tag {
    font-size: 12px;
    font-weight: 700;
    color: #2563eb;
  }
}

.nfs-list-box-content {
  max-height: 125px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 2px;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 2px;
  }

  .nfs-no-selection {
    font-size: 12px;
    color: #94a3b8;
    text-align: center;
    padding: 12px 0;
    font-style: italic;
  }
}

.nfs-apply-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #dbeafe;
  padding: 5px 8px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 500;
  box-sizing: border-box;
  line-height: 1.3;
  word-break: break-word;

  i {
    font-size: 13px;
    color: #10b981;
    flex-shrink: 0;
  }
}

/* Segmented Radio Buttons */
.send-type-segmented {
  display: flex !important;
  width: 100%;

  /deep/ .el-radio-button {
    flex: 1;
    display: flex;

    .el-radio-button__inner {
      width: 100%;
      border-radius: 6px !important;
      padding: 9px 12px;
      font-weight: 500;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      box-sizing: border-box;
    }
  }

  /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  /deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-left: 0 !important;
  }
}

.upload-drop-section {
  .upload-sublabel {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 6px;
    i {
      color: #3b82f6;
    }
  }
}

/* Drag & Drop Upload Zone Styling */
.drag-dropzone-uploader {
  width: 100%;
  /deep/ .el-upload {
    width: 100%;
    border: none !important;
    background: transparent !important;
  }
  /deep/ .el-upload-dragger {
    width: 100%;
    height: 70px;
    border-radius: 8px;
    border: 1.5px dashed #cbd5e1;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    transition: all 0.2s ease;

    &:hover {
      border-color: #2563eb;
      background-color: #eff6ff;
    }

    .el-icon-upload {
      font-size: 24px;
      color: #3b82f6;
      margin: 0;
      line-height: 1;
    }
    .el-upload__text {
      font-size: 11px;
      color: #64748b;
      em {
        color: #2563eb;
        font-weight: 600;
        font-style: normal;
      }
    }
  }
  /deep/ .el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;

    .el-upload-list__item {
      width: 70px;
      height: 70px;
      margin: 0;
      border-radius: 8px;
    }
  }
}

.drag-dropzone-file-uploader {
  width: 100%;
  /deep/ .el-upload {
    width: 100%;
  }
  /deep/ .el-upload-dragger {
    width: 100%;
    height: 70px;
    border-radius: 8px;
    border: 2px dashed #cbd5e1;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    transition: all 0.2s ease;

    &:hover {
      border-color: #2563eb;
      background-color: #eff6ff;
    }

    .el-icon-upload {
      font-size: 22px;
      color: #3b82f6;
      margin: 0;
      line-height: 1;
    }
    .el-upload__text {
      font-size: 11px;
      color: #64748b;
      em {
        color: #2563eb;
        font-weight: 600;
        font-style: normal;
      }
    }
  }
}
</style>
